import { render, staticRenderFns } from "./ProducerAdmin.vue?vue&type=template&id=63ee9d4a&scoped=true&"
import script from "./ProducerAdmin.vue?vue&type=script&lang=js&"
export * from "./ProducerAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ProducerAdmin.vue?vue&type=style&index=0&id=63ee9d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ee9d4a",
  null
  
)

export default component.exports